import { split, toUpper } from 'lodash';

export const buildAvatarName = username => {
    const splittedUsername = split(toUpper(username), ' ');
    const firstCharacter = splittedUsername[0];
    const lastCharacter = splittedUsername.length > 1 ? splittedUsername[splittedUsername.length - 1] : '';
    const nameInitials = `${firstCharacter.charAt(0)}${lastCharacter.charAt(0)}`;

    return nameInitials;
};
